export default {
  ru: {
    menu: {
      title_1: 'Привлечение клиентов',
      title_2: 'Создание команды',
      title_3: 'Подключение бизнесов',
      btn: 'Зарегистрироваться',
      login: 'Войти'
    },
    connect: {
      title: 'Создание команды партнеров',
      dsc: `Команда партнеров помогает вам строить бизнес на продвижении цифровых продуктов и клиентских сервисов, быстро масштабироваться и увеличивать свою прибыль.`,
      btn: 'Начать создавать команду'
    },
    dsc: {
      title: 'Как это работает?'
    },
    team_inside: {
      new: `Пригласить в команду`
    },
    team: `Вы работаете вместе с командой на построение клиентской  базы для магазинов. Чем эффективнее команда, тем выше доход каждого из партнеров.`,
    benefit: {
      shops: {
        title: 'Преимущества:',
        dsc: 'Бизнесы получают доступ к мощному онлайн-ресурсу, на котором зарегистрировано более 850 000 потенциальных покупателей, к сайту с 2 000 000 просмотров в месяц, к бесплатным каналам и инструментам для рекламы.',
        subtitle: 'Это дает магазинам:',
        ol: [
          `Готовый бизнес, который подстраивается под вас: вы сами решаете, сколько партнеров набирать в команду и сколько зарабатывать`,
          `Быстрая окупаемость и рост: время и внимание, которые вы уделяете своему бизнесу, сразу же трансформируются в результат`,
          `Командная работа: вы получаете поддержку от членов команды и прибыль от их бизнесов`
        ]
      },
      you: {
        title: `Первый шаг к созданию бизнес-команды – покупка мини-франшизы для продвижения кэшбэк-платформы и IT-продуктов SWITIPS. В каждую мини-франшизу входят:`,
        ol: [
          'Бизнес-модели «под ключ» и план построения своего дела',
          'Готовая система бизнеса с полноценным личным кабинетом статистики, обучения и аналитики',
          'Оптовое количество GOLD-карт по выгодной цене для продажи клиентам',
          'Маркетинговые материалы для презентаций и рекламы'
        ],
        btn: 'Зарегистрироваться'
      }
    }

  },
  en: {
    menu: {
      title_1: 'Attracting customers',
      title_2: 'Creating a team',
      title_3: 'Business Connection',
      btn: 'Sign up',
      login: 'Sign in'
    },
    connect: {
      title: 'Building a team of partners',
      dsc: `A team of partners helps you build a business on the promotion of digital products and customer services, quickly scale and increase your profits.`,
      btn: 'Start creating a team'
    },
    dsc: {
      title: 'How it works?'
    },
    team_inside: {
      new: `Invite to team`
    },
    team: `You work together with the team to build a customer base for stores.  The more effective the team, the higher the income of each partner.`,
    benefit: {
      shops: {
        title: 'Benefits',
        ol: [
          `A ready-made business that adapts to you: you decide how many partners to recruit into a team and how much to earn`,
          `Quick payback and growth: the time and attention you devote to your business are immediately transformed into a result`,
          `Teamwork: you get support from team members and profits from their businesses`
        ]
      },
      you: {
        title: `The first step in creating a business team is to buy a mini-franchise to promote cashback platforms and SWITIPS IT products. Each mini-franchise includes:`,
        ol: [
          'Business models and business plan',
          'Ready-made business system with a full-fledged personal account of statistics, training and analytics',
          'Wholesale quantity of GOLD-cards at a favorable price for sale to customers',
          'Marketing materials for presentations and advertising'
        ],
        btn: 'Sign Up'
      }
    }

  },
  ua: {
    menu: {
      title_1: 'Залучення клієнтів',
      title_2: 'Створення команди',
      title_3: 'Підключення бізнесів',
      btn: 'Зареєструватися',
      login: 'Увійти'
    },
    connect: {
      title: 'Створення команди партнерів',
      dsc: `Команда партнерів допомагає вам будувати бізнес на просуванні цифрових продуктів і клієнтських сервісів, швидко масштабуватися і збільшувати свій прибуток.`,
      btn: 'Почати створювати команду'
    },
    team_inside: {
      new: `Запросити в команду`
    },
    team: `Чим більше ваша команда, тим більше ви&nbsp;залучаєте клієнтів і&nbsp;тим вище ваш дохід, як&nbsp;спільний з&nbsp;командою, так і&nbsp;особистий.`,
    benefit: {
      shops: {
        title: 'Переваги:',
        ol: [
          `Готовий бізнес, який підлаштовується під вас: ви самі вирішуєте, скільки партнерів набирати в команду і скільки заробляти`,
          `Швидка окупність і зростання: час і увагу, які ви приділяєте своєму бізнесу, відразу ж трансформуються в результат`,
          `Командна робота: ви отримуєте підтримку від членів команди і прибуток від їх бізнесів`
        ]
      },
      you: {
        title: `Перший крок до створення бізнес-команди - покупка міні-франшизи для просування кешбек-платформи і IT-продуктів SWITIPS. У кожну міні-франшизу входять:`,
        ol: [
          'Бізнес-моделі «під ключ» і план побудови своєї справи',
          'Готова система бізнесу з повноцінним особистим кабінетом статистики, навчання і аналітики',
          'Оптова кількість GOLD-карт за вигідною ціною для продажу клієнтам',
          'Маркетингові матеріали для презентацій і реклами'
        ],
        btn: 'Зареєструватися'
      }
    }

  },
  kz: {
    menu: {
      title_1: 'Клиенттерді тарту',
      title_2: 'Команда құру',
      title_3: 'Іскерлік байланыс',
      btn: 'Тіркелу',
      login: 'Кіру'
    },
    connect: {
      title: 'Cеріктестер командасын құру',
      dsc: `Серіктестер тобы сізге сандық өнімдерді және клиенттерге қызмет көрсетуді жылжыту бойынша бизнестің құрылуына көмектеседі, пайдаңызды тез арада ұлғайтады және ұлғайтады.`,
      btn: 'Топты құруды бастаңыз'
    },
    team_inside: {
      new: `командаға шақыру`
    },
    team: `Сіз дүкендерде клиенттік базаны құру үшін командамен бірге жұмыс жасайсыз. Команда неғұрлым тиімді болса, серіктестердің әрқайсысының кірісі артады.`,
    benefit: {
      shops: {
        title: 'Артықшылықтары:',

        ol: [
          `Сізге бейімделген дайын бизнес: сіз қанша әріптесті командаға жалдауға және қанша ақша табуды шешесіз`,
          `Жылдам өтемақы және өсу: Сіздің бизнесіңізге арнаған уақыт пен көңіл дереу нәтижеге айналды`,
          `Командада жұмыс істеу: сіз команда мүшелерінен қолдау алып, өз бизнесіңіздің пайдасын аласыз`
        ]
      },
      you: {
        title: `Бизнес-топты құрудың алғашқы қадамы - Cashback платформаларын және SWITIPS IT өнімдерін алға жылжыту үшін франчайздарды сатып алу. Әрбір шағын франшиза мыналарды қамтиды:`,
        ol: [
          'кілттерді бизнес-модельдер және бизнес-жоспар',
          'статистиканың, оқытудың және талдаудың толыққанды жеке есебімен дайын бизнес жүйесі',
          'клиенттерге сату үшін қолайлы бағада GOLD-карталарының көтерме саны',
          'тұсаукесерлер мен жарнама үшін маркетингтік материалдар'
        ],
        btn: 'Тіркелу'
      }
    }

  }
}
